export default "__VITE_ASSET__BaAgjcfu__"